/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MaskedCompanyIntegration } from "./MaskedCompanyIntegration";
import {
  MaskedCompanyIntegrationFromJSON,
  MaskedCompanyIntegrationFromJSONTyped,
  MaskedCompanyIntegrationToJSON,
  MaskedCompanyIntegrationToJSONTyped,
} from "./MaskedCompanyIntegration";

/**
 *
 * @export
 * @interface UnreadableIntegration
 */
export interface UnreadableIntegration {
  /**
   *
   * @type {MaskedCompanyIntegration}
   * @memberof UnreadableIntegration
   */
  integration: MaskedCompanyIntegration;
  /**
   *
   * @type {string}
   * @memberof UnreadableIntegration
   */
  reason: string;
}

/**
 * Check if a given object implements the UnreadableIntegration interface.
 */
export function instanceOfUnreadableIntegration(
  value: object,
): value is UnreadableIntegration {
  if (!("integration" in value) || value["integration"] === undefined)
    return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  return true;
}

export function UnreadableIntegrationFromJSON(
  json: any,
): UnreadableIntegration {
  return UnreadableIntegrationFromJSONTyped(json, false);
}

export function UnreadableIntegrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UnreadableIntegration {
  if (json == null) {
    return json;
  }
  return {
    integration: MaskedCompanyIntegrationFromJSON(json["integration"]),
    reason: json["reason"],
  };
}

export function UnreadableIntegrationToJSON(json: any): UnreadableIntegration {
  return UnreadableIntegrationToJSONTyped(json, false);
}

export function UnreadableIntegrationToJSONTyped(
  value?: UnreadableIntegration | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integration: MaskedCompanyIntegrationToJSON(value["integration"]),
    reason: value["reason"],
  };
}
